import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { colors } from '../../../../theme/styled';
import { title } from '../../../../theme/typography';
import { media } from '../../../../theme/media';

let subMenuBackgroundColor = colors.darkGrey;

export const MenuLinkList = styled.ul`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  right: -10em;
  padding: 1em 1.5em;
  opacity: 0;
  min-width: 12em;
  width: 14em;
  transform: translateY(20px) translateX(-50%) scaleY(0);
  z-index: 1;

  background: ${subMenuBackgroundColor};
  box-shadow: 0 0 28px rgba(61,90,113,.4);

  font-size: 13px;

  ${media.desktop`
    font-size: 14px;
  `};

  list-style: none;


  &::before {
    content: '';
    position: absolute;
    top: -6px;
    right: 2.9em;
    z-index: -1;
    width: 14px;
    height: 14px;
    transform: rotate(45deg);

    background: ${subMenuBackgroundColor};
    box-shadow: -4px -4px 4px rgba(61,90,113,.4);
  }

  animation-duration: .4s;

  .has-hovered:not(.hovered) & {
    animation-name: 'down-and-out';
    animation-duration: .4s;
  }

  .hovered & {
    transform: translateY(-5px) translateX(-50%);
    opacity: 1;
    animation-name: up-and-in;
  }
`;

export const MenuSubListItem = styled.li`
  &:first-of-type {
    padding-top: 1em;
  }
`;

export const MenuSubLink = styled(NavLink)`
  ${title};
  display: block;
  padding-bottom: 1em;

  color: ${colors.white};
  text-align: left;
  width: 100%;
  transition: color .15s ease-in-out;

  &:hover {
    color: ${colors.accessibilityYellow};
  }
`;

export const MenuSubLinkExternal = styled(MenuSubLink).attrs({ as: 'a' })``;
